import React, { useEffect, useState } from 'react';
import './dynamicBar.scss';
import { InlineLoading } from 'carbon-components-react';
import PublicImage from 'src/common/components/PublicImage';

const simple = 'images/Simple.png';
const moderate = 'images/Moderate.png';
const complex = 'images/Complex.png';
const initial = 'images/Initial.png';

interface DynamicBarProps {
  topText: string;
  bottonText: string;
  annual_spend: number;
  number_department: number;
  number_participants: number;
  calculate: boolean;
  setCalculate: React.Dispatch<React.SetStateAction<boolean>>;
  setResult: React.Dispatch<React.SetStateAction<string>>;
}

const DynamicsBar: React.FC<DynamicBarProps> = ({
  topText,
  bottonText,
  annual_spend,
  number_department,
  number_participants,
  calculate,
  setCalculate,
  setResult,
}) => {
  const [image, setImage] = useState(initial);
  const [calculating, setCalculating] = useState(false);
  const getROI = (
    aSpend: number,
    nDepartment: number,
    nParticipants: number,
  ) => {
    let result = 'simple' as string;
    setImage(
      nDepartment === 1
        ? simple
        : nDepartment >= 2 && nDepartment <= 4
        ? moderate
        : nDepartment >= 5
        ? complex
        : initial,
    );

    result =
      nDepartment === 1
        ? 'simple'
        : nDepartment > 1 && nDepartment < 5
        ? 'moderate'
        : nDepartment > 4
        ? 'complex'
        : 'initial';

    if (aSpend >= 500 && nDepartment >= 1 && nDepartment <= 4) {
      result = 'complex';
      setImage(complex);
    }

    if (nParticipants >= 151 && nDepartment >= 1 && nDepartment <= 4) {
      result = 'complex';
      setImage(complex);
    }
    setResult(result);
    setCalculate(false);
  };
  useEffect(() => {
    if (calculate) {
      !calculating ? setCalculating(true) : '';
      setTimeout(() => {
        setCalculating(false);
      }, 2000);
    }
    if (calculate && !calculating) {
      getROI(annual_spend, number_department, number_participants);
    }
  }, [annual_spend, number_department, number_participants, calculate]);

  return (
    <>
      {calculating ? (
        <InlineLoading
          status="active"
          iconDescription="Loading"
          description="Calculating ROI..."
        />
      ) : (
        <PublicImage
          imgPath={image}
          widgetId="planning-analytics-roi"
          id="img1"
          alt=""
          className="dynamicsBar"
        />
      )}
    </>
  );
};
export default DynamicsBar;
